import React, { ReactNode } from 'react';
import styles from './SettingsSectionHeader.module.css';

type Props = {
  color: string;
  title: string | ReactNode;
  icon: ReactNode;
  headerComponent?: ReactNode;
  children?: ReactNode;
};

export const SettingsSectionHeader = ({
  icon,
  color,
  title,
  headerComponent,
  children,
}: Props) => (
  <div className={styles.container}>
    <div className={styles.headerWrapper}>
      <div className={styles.titleWrapper}>
        <div className={styles.icon} style={{ backgroundColor: color }}>
          {icon}
        </div>
        <div className={styles.title}>{title}</div>
      </div>
      <div>{headerComponent}</div>
    </div>

    {children}
  </div>
);
